export const expander = document.getElementById('search-expander');
export const overlay = document.getElementById('search-overlay');

export function testSearchExpander() {
    if (expander.style.visibility === 'hidden') {
        showSearchExpander();
    } else {
        hideSearchExpander();
    }
}

export function showSearchExpander() {
    expander.style.visibility = 'visible';
    expander.style.opacity = '1';
    overlay.style.visibility = 'visible';
    overlay.style.opacity = '0.6';
}

export function hideSearchExpander() {
    expander.style.visibility = 'hidden';
    expander.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    overlay.style.opacity = '0';
}

export function focusState() {
    document.getElementById("search-input").focus();
}

export function removeFocusState() {
    document.getElementById("search-input").blur();
}
